const publisherRoles = {
	ADMIN: "publisherAdmin",
	RESOURCE: "publisherStaff",
};

export default publisherRoles;
